import { NavLink, Outlet, Navigate, useNavigate } from "react-router-dom";
import { LogOut, Plus } from "lucide-react";
import { PlenaLogo } from "@/components/brand/PlenaLogo";
import { Button } from "@/components/ui/button";
import { Spinner } from "@/components/common";
import { useAuth } from "@/features/auth/AuthContext";
import { cn } from "@/lib/utils";

const NAV = [
  { to: "/admin", label: "Genel Bakış", end: true, id: "nav-overview" },
  { to: "/admin/evaluations", label: "Değerlendirmeler", id: "nav-evaluations" },
  { to: "/admin/evaluators", label: "Değerlendiriciler", id: "nav-evaluators" },
  { to: "/admin/results", label: "Sonuçlar", id: "nav-results" },
  { to: "/admin/exports", label: "Dışa Aktar", id: "nav-exports" },
];

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  if (user === null) return <Spinner />;
  if (user === false) return <Navigate to="/login" replace />;

  return (
    <div className="min-h-screen">
      <header className="sticky top-0 z-40 border-b border-plena-border bg-white/90 backdrop-blur-md">
        <div className="mx-auto flex h-14 max-w-6xl items-center gap-8 px-4 sm:px-6">
          <NavLink to="/admin" className="flex items-center gap-3" data-testid="nav-logo">
            <PlenaLogo height={22} />
          </NavLink>
          <nav className="hidden items-center gap-1 md:flex" aria-label="Ana menü">
            {NAV.map((n) => (
              <NavLink
                key={n.to}
                to={n.to}
                end={n.end}
                data-testid={n.id}
                className={({ isActive }) =>
                  cn("rounded-full px-3 py-1.5 text-sm font-medium transition-colors duration-150", isActive ? "bg-plena-surface2 text-plena-text" : "text-plena-text2 hover:text-plena-text")
                }
              >
                {n.label}
              </NavLink>
            ))}
          </nav>
          <div className="ml-auto flex items-center gap-2">
            <Button data-testid="new-evaluation-button" size="sm" onClick={() => nav("/admin/evaluations/new")} className="btn-press rounded-full">
              <Plus className="mr-1.5 h-4 w-4" /> Yeni Değerlendirme
            </Button>
            <Button data-testid="logout-button" size="sm" variant="ghost" onClick={logout} className="rounded-full text-plena-text2" aria-label="Çıkış">
              <LogOut className="h-4 w-4" />
            </Button>
          </div>
        </div>
        <nav className="flex gap-1 overflow-x-auto px-4 pb-2 md:hidden">
          {NAV.map((n) => (
            <NavLink key={n.to} to={n.to} end={n.end} className={({ isActive }) => cn("whitespace-nowrap rounded-full px-3 py-1 text-xs font-medium", isActive ? "bg-plena-surface2" : "text-plena-text2")}>
              {n.label}
            </NavLink>
          ))}
        </nav>
      </header>
      <main className="mx-auto max-w-6xl px-4 py-10 sm:px-6">
        <Outlet />
      </main>
    </div>
  );
}
